"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRESET = exports.PRE_DEFINED_PRESETS = exports.PRESETS = void 0;
const client_1 = require("@apollo/client");
exports.PRESETS = (0, client_1.gql) `
  query Presets(
    $entitlementId: Int
    $search: String
    $timestamp: Int
    $limit: Int
    $order: Int
  ) {
    restricted {
      presets(
        entitlementId: $entitlementId
        search: $search
        timestamp: $timestamp
        limit: $limit
        order: $order
      ) {
        id
        createdAt
        updatedAt
        name
        likes
        entitlementId
        entitlement {
          id
          name
        }
        correctQuestions
        incorrectQuestions
        completedQuestions
        totalQuestions
        yellowCards
        greenCards
        redCards
        completedCards
        totalCards
        userId
        concepts {
          id
          name
          topicId
        }
      }
    }
  }
`;
exports.PRE_DEFINED_PRESETS = (0, client_1.gql) `
  query PreDefinedPresets($entitlementId: Int, $search: String, $order: Int) {
    restricted {
      preDefinedPresets(
        entitlementId: $entitlementId
        search: $search
        order: $order
      ) {
        id
        createdAt
        updatedAt
        name
        likes
        entitlementId
        entitlement {
          id
          name
        }
        correctQuestions
        incorrectQuestions
        completedQuestions
        totalQuestions
        yellowCards
        greenCards
        redCards
        completedCards
        totalCards
        userId
        concepts {
          id
          name
          topicId
        }
      }
    }
  }
`;
exports.PRESET = (0, client_1.gql) `
  query Preset($id: Int!) {
    restricted {
      preset(id: $id) {
        id
        createdAt
        updatedAt
        name
        likes
        entitlementId
        entitlement {
          id
          name
        }
        correctQuestions
        incorrectQuestions
        completedQuestions
        totalQuestions
        yellowCards
        greenCards
        redCards
        completedCards
        totalCards
        userId
        concepts {
          id
          name
          topicId
        }
      }
    }
  }
`;
